module.exports = __webpack_public_path__ + "static/media/comoLlegar.31ddb5be.webp";